module.exports = __webpack_public_path__ + "img/inactivesection.333ed364.svg";